import React from 'react';
import { SkeletonRegistryItem } from '../../../registry/skeleton/SkeletonRegistryItem';
import { SkeletonRegistryCategory } from '../../../registry/skeleton/SkeletonRegistryCategory';
import { runtime } from '../../../classes/runtime/Runtime';
import { Aspect_ } from '../../../components/actor/Aspect_';
import { Actor_ } from '../../../components/actor/Actor_';
export class SkeletonsMultipleChoice extends SkeletonRegistryCategory {
    label = 'MultipleChoice';
    constructor(parent) {
        super(parent);
        super.init();
    }
    /*
    readonly joerfsj = () =>
      new SkeletonRegistryItem({
        // label: 'Questiontext replaced _ with solution',
        jsx: ({ actor, at, questionMultipleChoice }) => {
          if (!questionMultipleChoice) return null;
          return (
            <span
              key="ts"
              dangerouslySetInnerHTML={{
                __html: questionMultipleChoice.multipleChoiceSpecials.questionTextWithReplacedPlaceHolders(actor)
              }}
            />
          );
        }
      });
  */
    multipleChoiceCorrectTextBasis = () => new SkeletonRegistryItem({
        /*   label: 'Correct TextBasis', */
        jsx: ({ question }) => {
            if (!(question instanceof runtime.class.QuestionMultipleChoice))
                return null;
            const option = question.options.find(option => option.shouldBeSelected);
            if (!option)
                return null;
            return option.text.textBasis;
        },
    });
    draftMultipleChoiceStructure_base = () => new SkeletonRegistryItem({
        label: 'Wrapped Options',
        jsx: ({ question }) => {
            if (!question)
                return null;
            const question_ = question;
            return (React.createElement(Aspect_, { aspect: question_.inner },
                React.createElement(Actor_, { actor: question_.questionPart }),
                React.createElement(Aspect_, { aspect: question_.ownAspect.options }, question_.shuffledOptions.map(option => (React.createElement(Actor_, { actor: option, key: option.tid }))))));
        },
    });
    draftMultipleChoiceStructure_withoutOptions = () => new SkeletonRegistryItem({
        label: 'Without Options',
        jsx: ({ question }) => {
            if (!question)
                return null;
            const question_ = question;
            return (React.createElement(Aspect_, { aspect: question_.inner },
                React.createElement(Actor_, { actor: question_.questionPart })));
        },
    });
    draftMultipleChoiceStructure_naked = () => new SkeletonRegistryItem({
        label: 'Naked Options',
        jsx: ({ question }) => {
            if (!question)
                return null;
            const question_ = question;
            return (React.createElement(Aspect_, { aspect: question_.inner },
                React.createElement(Actor_, { actor: question_.questionPart, key: "qp" }),
                question_.shuffledOptions.map(option => (React.createElement(Actor_, { actor: option, key: option.tid })))));
        },
    });
}
